module.exports = __webpack_public_path__ + "static/Lovelo_Black-486d31bb5de7d59cb4e8a83510c98331.ttf";